import { useState, useEffect } from 'react';
import CustomerProfileService from './CustomerProfileService';
import { useSelector } from 'react-redux';

const useCustomerProfile = () => {
  const [profiles, setProfiles] = useState(null)
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [profile, setProfile] = useState()
  const shopName = useSelector((state) => state.shop.name);

  const getNewCustomerOrder = async () => {
    setIsLoading(true);
    try {
      const response = await CustomerProfileService.getNewCustomerOrder({shop: shopName});
      setProfiles(response.data);
      console.log(response.data)
      setError(null);
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const getFollowProfile = async (formData) => {
    setIsLoading(true);
    try {
      const response = await CustomerProfileService.getFollowProfile(formData);
      setProfiles(response.data);
      console.log(response.data)
      setError(null);
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const addCustomerProfile = async (profile) => {
    let result = true
    setIsLoading(true);
    try {
      const updatedProfile = { ...profile, shop: shopName };
      await CustomerProfileService.addCustomerProfile(updatedProfile);
      result = true
    } catch (err) {
      console.log(err)
        result = err.response?.data?.message || err.message || 'An error occurred.';
        console.log(err.response?.data?.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  };

  const updateProfile = async (profile) => {
    let result = true
    setIsLoading(true);
    try {
        const updatedProfile = { ...profile, shop: shopName }
        await CustomerProfileService.updateProfile(updatedProfile);
        result = true
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const updateProfileProductGroup = async (formData) => {
    let result = true
    setIsLoading(true);
    try {
      const updatedFormData = {...formData, shop:shopName}
        const response = await CustomerProfileService.updateProfileProductGroup(updatedFormData);
        console.log(response)
        result = true
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const updateSendSameAddress = async (profile) => {
    let result = true
    setIsLoading(true);
    try {
        const updatedProfile = { ...profile, shop: shopName }
        await CustomerProfileService.updateSendSameAddress(updatedProfile);
        result = true
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const updateSocialId = async (profile) => {
    let result = true
    setIsLoading(true);
    try {
        await CustomerProfileService.updateSocialId(profile);
        result = true
    } catch (err) {
        result = err.response?.data?.message || false
        console.log(err)
        console.log(err.response?.data?.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const getBlacklistProfile = async () => {
    let result = true
    setIsLoading(true);
    try {
        const response = await CustomerProfileService.getBlacklistProfile({shop: shopName});
        setProfiles(response.data)
        result = true
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const getVipProfile = async () => {
    let result = true
    setIsLoading(true);
    try {
        const response = await CustomerProfileService.getVipProfile({shop: shopName});
        setProfiles(response.data)
        result = true
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const checkBlacklist = async (customerId) => {
    let result = true
    setIsLoading(true);
    try {
        const response = await CustomerProfileService.checkBlacklist(customerId);
        const responseAmount = response.data.unpaidPercentage
        console.log(responseAmount)
        if(responseAmount > 70){
          result = 'ng'
        }else{
          result = 'ok'
        }
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const removeProfileFromBlacklist = async (customerId) => {
    let result = true
    setIsLoading(true);
    try {
        const response = await CustomerProfileService.removeProfileFromBlacklist(customerId);
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const addProfileToBlacklist = async (customerId) => {
    let result = true
    setIsLoading(true);
    try {
        await CustomerProfileService.addProfileToBlacklist(customerId);
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response?.data?.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const checkAndRemoveBlacklistIfNeeded = async (customerId) => {
    let result = { removed: false, error: null };
    setIsLoading(true);
    try {
        const response = await CustomerProfileService.checkAndRemoveBlacklistIfNeeded(customerId);
        // Backend should return: { removed: boolean, message?: string }
        result = response.data;
    } catch (err) {
        result = { removed: false, error: err.response?.data?.message || 'An error occurred.' };
        console.log(err);
    } finally {
        setIsLoading(false);
    }
    return result;
  }

  const getCustomerDetails = async (customerId) => {
    let result = true
    setIsLoading(true);
    try {
        const response = await CustomerProfileService.getCustomerDetails(customerId);
        result = response.data;
        console.log(result)
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const followCrm = async (formData) => {
    let result = true
    setIsLoading(true);
    try {
        const response = await CustomerProfileService.followCrm(formData);
        await getFollowProfile();
    } catch (err) {
        result = false
        console.log(err)
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const createCustomerRateAdjustment = async (data) => {
    let result = true
    setIsLoading(true);
    try {
        const updatedData = { ...data, shop: shopName };
        await CustomerProfileService.createCustomerRateAdjustment(updatedData);
        result = true
    } catch (err) {
        result = err?.response?.data?.message || false
        console.log(err)
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const getCustomerRateAdjustments = async (customerId) => {
    let result = null
    setIsLoading(true);
    try {
        const response = await CustomerProfileService.getCustomerRateAdjustments(customerId);
        result = response.data.data
    } catch (err) {
        result = false
        console.log(err)
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const updateCustomerRateAdjustment = async (data) => {
    let result = true
    setIsLoading(true);
    try {
        const updatedData = { ...data};
        await CustomerProfileService.updateCustomerRateAdjustment(updatedData);
        result = true
    } catch (err) {
        result = err?.response?.data?.message || false
        console.log(err)
    } finally {
        setIsLoading(false);
    }
    return result
  }
  
  return { 
    profiles,
    isLoading,
    getVipProfile, 
    addCustomerProfile, 
    updateProfile, 
    updateSendSameAddress,
    updateSocialId,
    getBlacklistProfile, 
    checkBlacklist,
    removeProfileFromBlacklist,
    addProfileToBlacklist,
    checkAndRemoveBlacklistIfNeeded,
    getFollowProfile,
    getCustomerDetails,
    followCrm,
    getNewCustomerOrder,
    updateProfileProductGroup,
    createCustomerRateAdjustment,
    getCustomerRateAdjustments,
    updateCustomerRateAdjustment
   };
}

export default useCustomerProfile;
